import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'myabvv-key-value',
    standalone: true,
    templateUrl: './key-value.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeyValueComponent implements OnInit {
  @Input() key: string;
  @Input() value: string;
  @Input() unit: string;
  @Input() alt: string;
  @Input() loading = false;


  constructor() { }

  ngOnInit() {}

}
